import { breakpoints, type BreakpointKey } from "../../tokens";

/**
 * Resolve the current breakpoint key from a viewport width in pixels.
 */
export function resolveBreakpoint(width: number): BreakpointKey {
  if (width >= breakpoints.xl) return "xl";
  if (width >= breakpoints.lg) return "lg";
  if (width >= breakpoints.md) return "md";
  return "sm";
}
